module.exports = __webpack_public_path__ + "static/media/logo_luojizhihui.5515cf2e.png";